import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

// 修复 Vue Router 3 的导航 Uncaught Promise rejection
// vue-router 3.1+ 的 push/replace 返回 Promise，导航被中断时(重定向/取消/重复，
// 如未登录访问 /user → 守卫 next('/login') 重定向)会 reject，调用方未 catch 就变成
// "Navigation cancelled/Duplicated" Uncaught runtime error。统一吞掉这类预期中断。
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(() => {})
}
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(() => {})
}

const routes = [
  { path: '/login', component: () => import('@/views/login/Index.vue'), meta: { public: true } },
  // 飞书免登回调（公开：飞书授权后带 code+state 重定向到这）
  { path: '/feishu-callback', name: '飞书登录回调', component: () => import('@/views/login/FeishuCallback.vue'), meta: { public: true } },
  // 工具选择页（登录后首页：盘客系统/营销系统/客服系统三入口，点击时按角色鉴权）
  { path: '/tools', name: '工具选择', component: () => import('@/views/tools/Index.vue'), meta: { hidden: true } },
  // 无权限提示页（路由守卫 perm 拦截 / 接口 403 时引导到这；?perm=权限开关key）
  { path: '/no-perm', name: '无权限', component: () => import('@/views/common/NoPerm.vue'), meta: { hidden: true } },
  {
    path: '/',
    component: () => import('@/layout/Layout.vue'),
    redirect: '/tools',          // 根路径先进工具选择页；/plan 等子路由由卡片/菜单进入
    meta: { pankeOnly: true },   // 盘客主系统：EMPLOYEE(员工)角色禁止进入（守卫弹回 /tools）
    children: [
      // 盘客计划（顶层，优先级高于盘客管理；功能待定，先占位）
      { path: 'plan', name: '盘客计划', component: () => import('@/views/plan/Index.vue'), meta: { group: 'plan', icon: 'el-icon-pie-chart' } },
      // 全层抗衰需求评估问诊表（独立页面，从盘客计划·评估依据进入；不在菜单显示）
      { path: 'plan/aging-assessment', name: '全层抗衰问诊表', component: () => import('@/views/plan/AgingAssessmentPage.vue'), meta: { hidden: true } },
      { path: 'plan-history', name: '盘客历史', component: () => import('@/views/plan/HistoryPage.vue'), meta: { group: 'plan', icon: 'el-icon-document' } },
      { path: 'plan-calendar', name: '盘客日历', component: () => import('@/views/plan/CalendarPage.vue'), meta: { group: 'plan', icon: 'el-icon-date' } },
      // 盘客管理（现有功能归入此组）
      { path: 'panke', name: '今日盘客', component: () => import('@/views/user/PankeToday.vue'), meta: { group: 'manage', icon: 'el-icon-date' } },
      { path: 'customer/:id', name: '顾客详情', component: () => import('@/views/user/CustomerDetail.vue'), meta: { hidden: true } },
      // 系统管理（管理端）
      { path: 'rule/project', name: '项目维护', component: () => import('@/views/admin/RuleProject.vue'), meta: { group: 'system', role: 'ADMIN', icon: 'el-icon-setting' } },
      { path: 'rule/relation', name: '关联规则', component: () => import('@/views/admin/RuleRelation.vue'), meta: { group: 'system', role: 'ADMIN' } },
      { path: 'rule/medical', name: '医嘱模板', component: () => import('@/views/admin/RuleMedicalOrder.vue'), meta: { group: 'system', role: 'ADMIN' } },
      { path: 'sync', name: '同步监控', component: () => import('@/views/admin/SyncMonitor.vue'), meta: { group: 'system', role: 'ADMIN', icon: 'el-icon-refresh' } },
      { path: 'data-source', name: '数据源', component: () => import('@/views/admin/DataSource.vue'), meta: { group: 'system', role: 'ADMIN' } },
      { path: 'preference', name: '喜好线索', component: () => import('@/views/admin/Preference.vue'), meta: { group: 'system', role: 'ADMIN' } },
      { path: 'ai-config', name: 'AI配置', component: () => import('@/views/admin/AiConfig.vue'), meta: { group: 'system', role: 'ADMIN' } },
      { path: 'ai-log', name: 'AI日志', component: () => import('@/views/admin/AiLog.vue'), meta: { group: 'system', role: 'ADMIN' } },
      { path: 'operation-log', name: '操作日志', component: () => import('@/views/admin/OperationLog.vue'), meta: { group: 'system', role: 'ADMIN' } },
      { path: 'alert', name: '系统告警', component: () => import('@/views/admin/AlertManage.vue'), meta: { group: 'system', role: 'ADMIN', icon: 'el-icon-bell' } },
      { path: 'skin-log', name: '皮肤检测', component: () => import('@/views/admin/SkinLog.vue'), meta: { group: 'system', role: 'ADMIN' } },
      { path: 'wecom-archive', name: '会话存档', component: () => import('@/views/admin/WecomArchive.vue'), meta: { group: 'system', role: 'ADMIN', icon: 'el-icon-chat-line-square' } },
      { path: 'plan-eval', name: '方案评测', component: () => import('@/views/admin/PlanEval.vue'), meta: { group: 'system', role: 'ADMIN' } },
      { path: 'user', name: '用户管理', component: () => import('@/views/admin/SysUser.vue'), meta: { group: 'system', role: ['SUPERVISOR', 'ADMIN'] } },
      { path: 'store', name: '门店管理', component: () => import('@/views/admin/StoreManage.vue'), meta: { group: 'system', role: 'ADMIN' } },
      { path: 'project', name: '项目管理', component: () => import('@/views/admin/ProjectManage.vue'), meta: { group: 'system', role: 'ADMIN', icon: 'el-icon-goods' } },
      { path: 'package', name: '套餐管理', component: () => import('@/views/admin/PackageManage.vue'), meta: { group: 'system', role: 'ADMIN', icon: 'el-icon-box' } },
      { path: 'customer', name: '顾客管理', component: () => import('@/views/admin/CustomerManage.vue'), meta: { group: 'system', role: 'ADMIN', icon: 'el-icon-user-solid' } },
      { path: 'customer-segment', name: '顾客分层', component: () => import('@/views/admin/CustomerSegment.vue'), meta: { group: 'manage', role: 'ADMIN', icon: 'el-icon-data-analysis' } },
      { path: 'panke-pool', name: '盘客池管理', component: () => import('@/views/admin/PankePoolManage.vue'), meta: { group: 'system', role: 'ADMIN', icon: 'el-icon-s-custom' } },
      { path: 'visit-monitor', name: '划扣回访监控', component: () => import('@/views/admin/VisitMonitorPage.vue'), meta: { group: 'system', role: 'ADMIN', icon: 'el-icon-phone-outline' } },
      // 主管/管理员
      { path: 'monitor', name: '监控看板', component: () => import('@/views/admin/Monitor.vue'), meta: { group: 'system', role: ['SUPERVISOR', 'ADMIN'] } },
      { path: 'plan-monitor', name: '盘客管控', component: () => import('@/views/plan/MonitorPage.vue'), meta: { group: 'system', role: ['SUPERVISOR', 'ADMIN'], icon: 'el-icon-data-analysis' } },
      { path: 'plan-target', name: '目标分配', component: () => import('@/views/plan/TargetPage.vue'), meta: { group: 'system', role: 'ADMIN', icon: 'el-icon-money' } },
      { path: 'daily-report', name: '每日报告', component: () => import('@/views/admin/DailyReport.vue'), meta: { group: 'system', role: ['SUPERVISOR', 'ADMIN'] } }
    ]
  },
  // 医嘱单·独立端（顶层路由：脱离盘客 Layout 自带顶栏壳，入口在 /tools 工具选择·盘客卡内；按医嘱权限放行）
  { path: '/medical-order', name: '医嘱单', component: () => import('@/views/medicalorder/Index.vue'), meta: { hidden: true, perm: 'permMedicalOrder' } },
  // 医嘱统计·独立端（划扣人员×医嘱执行率；入口在医嘱单页 Tab；按医嘱权限放行）
  { path: '/medical-order-stats', name: '医嘱统计', component: () => import('@/views/medicalorder/StatsApp.vue'), meta: { hidden: true, perm: 'permMedicalOrder' } },
  // 海报生成Agent·独立端（顶层路由：不进 Layout、不用 ElementUI、自带全新设计系统；营销权限默认全员开，管理员可关）
  { path: '/poster', name: '海报工坊', component: () => import('@/views/poster/PosterPage.vue'), meta: { hidden: true, perm: 'permPoster' } },
  // 公司素材库（海报/物料/朋友圈三分类瀑布流；生成图经用户确认收录后入库）
  { path: '/poster-materials', name: '素材库', component: () => import('@/views/poster/components/PosterMaterialPage.vue'), meta: { hidden: true, perm: 'permPoster' } },
  // 回访记录·独立端（工作台第四卡：当日回访清单×电话/聊天双截图AI判定；照医嘱单先例顶层路由+独立壳，员工不开盘客权限也能用）
  { path: '/visit-record', name: '回访记录', component: () => import('@/views/visitrecord/Index.vue'), meta: { hidden: true, perm: 'permVisitRecord' } },
  // 年度美容规划书·独立端（工作台盘客横条入口：检索顾客→按Excel模板生成→历史按姓名/电话查；权限默认关逐个分配，91号SQL）
  { path: '/annual-plan', name: '年度规划', component: () => import('@/views/annualplan/Index.vue'), meta: { hidden: true, perm: 'permAnnualPlan' } },
  // 兜底：未匹配的路径回工具选择页（已登录）或登录页
  { path: '*', redirect: '/tools' }
]

const router = new VueRouter({ mode: 'history', routes })

// 未登录访问工具独立端时，登录页带上目标工具（?to=）——飞书启用时登录页自动发起免登直达
function targetOfPath(path) {
  if (path === '/medical-order' || path === '/medical-order-stats') return 'medical-order'
  if (path === '/poster' || path === '/poster-materials') return 'poster'
  if (path === '/visit-record') return 'visit-record'
  if (path === '/annual-plan') return 'annual-plan'
  return ''
}

// 路由守卫：登录校验 + 角色校验 + 员工禁入盘客主系统
router.beforeEach((to, from, next) => {
  if (to.meta.public) return next()
  if (!store.getters.isLogin) {
    const to2 = targetOfPath(to.path)
    return next(to2 ? { path: '/login', query: { to: to2 } } : '/login')
  }

  // 功能权限守卫（84号SQL三开关）：meta.perm 指定所需权限 getter 名，不足 → 无权限提示页
  const permKey = to.meta && to.meta.perm
  if (permKey && !store.getters[permKey]) {
    return next({ path: '/no-perm', query: { perm: permKey } })
  }

  // 盘客主系统路由（Layout 及其子页）：按盘客权限开关放行（管理员在用户管理可关）
  if (to.matched.some(r => r.meta && r.meta.pankeOnly) && !store.getters.permPanke) {
    return next({ path: '/no-perm', query: { perm: 'permPanke' } })
  }

  // 角色校验
  const required = to.meta.role
  if (required) {
    const role = store.getters.role
    const ok = Array.isArray(required) ? required.includes(role) : required === role
    if (!ok) {
      Vue.prototype.$message.error('无权限访问')
      return next('/tools')
    }
  }
  next()
})

export default router
